import storeProvider from '../storeProvider';

import { showConfirmationModal } from '../actions/App';
import { setUserSetting } from '../actions/Auth';

import { APIupdateUserSettingValue } from '../api/User';

import {
  setPostHogUser,
  sendTrackingEvent,
} from '.';
import { getState } from './App';
import {
  userIsAdmin,
  userIsManager,
} from './Auth';
import { getIntl } from './IntlInstance';
import { getUserSetting } from './Settings';
import { eventDispatch } from './Events';

export const getOnboardingSteps = () => {
  if (userIsAdmin() || userIsManager()) {
    return [
      'initial-step',
      'collection-created',
      'tags-added',
      'share-complete',
      'user-invited',
    ];
  }

  return [];
};

export const isOnboardingStepCompleted = (slug) => {
  const onboardingSteps = getUserSetting('onboarding_steps') || [];
  return !!(onboardingSteps.find(s => s.slug === slug && s.completed));
};

export const performOnboardingStep = async (slug, skipped = false) => {
  const state = getState();
  const store = storeProvider.getStore();

  if (isOnboardingStepCompleted(slug)) return;

  const response = await APIupdateUserSettingValue(state.Auth.profile.uuid, 'onboarding_steps', {
    slug,
    completed: true,
    skipped: !!skipped,
  });

  store.dispatch(setUserSetting({ onboarding_steps: response.data }));
  setTimeout(() => {
    eventDispatch('performedOnboardingStep');
    if (skipped) {
      sendTrackingEvent('Onboarding step completed', { step: slug });
    } else {
      sendTrackingEvent('Onboarding step skipped', { step: slug });
    }
    setPostHogUser(state.Auth.profile);
  }, 500);
};

export const handleSkipOnboardingStep = (slug) => {
  const store = storeProvider.getStore();
  const intl = getIntl();

  const modalParams = {
    title: intl.formatMessage({ defaultMessage: 'Are you sure?' }),
    text: intl.formatMessage({
      defaultMessage: `Are you sure you want to skip this step?`,
    }),
    confirmText: intl.formatMessage({ defaultMessage: 'Skip' }),
    onConfirm: () => (
      performOnboardingStep(slug, true)
    ),
  };

  store.dispatch(showConfirmationModal(modalParams));
};

export const getInitialOpenOnboardingStep = () => {
  const userSteps = getUserSetting('onboarding_steps');
  const userCompletedSteps = userSteps ?
    userSteps.filter(s => s.completed === true).map(s => s.slug) : [];
  const incompleteSteps = getOnboardingSteps().filter(s => !userCompletedSteps.includes(s));

  return incompleteSteps.length > 0 ? incompleteSteps[0] : null;
};
